import React from 'react'

export const FormWizardItem = ({complete, title, description, onClick}) => (
    <div className={'col-xs-3 bs-wizard-step ' + (complete ? 'complete' : 'disabled')}>
        <div className="text-center bs-wizard-stepnum">{title}</div>
        <div className="progress"><div className="progress-bar"></div></div>
        <a href="#" className="bs-wizard-dot" onClick={ e => { e.preventDefault(); onClick(e) }}></a>
        <div className="bs-wizard-info text-center">{description}</div>
    </div>
)

const FormWizard = ({children, onStepClick = () => {}}) => {
    return (
        <div className="bs-wizard"> 
            {React.Children.map(children, (child, idx) => Object.assign({}, child, {
                props: Object.assign({}, child.props, {
                    onClick: () => onStepClick(idx + 1)
                })
            }))}
        </div>
    )
}

export default FormWizard



// WEBPACK FOOTER //
// ./components/FormWizard.jsx